import { usePermissionContext, type PermissionContextValue } from '@/permissions/PermissionContext';

/**
 * Preferred hook for UI-level RBAC gating.
 *
 * @example
 * const { can } = usePermission();
 * if (can('finance.read')) { ... }
 */
export function usePermission(): PermissionContextValue {
  return usePermissionContext();
}
